import { IconConfig } from "../types";

export const building: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 57 58",
  elements: [
    {
      type: 'g',
      children: [
        {
          type: 'g',
          children: [
            {
              type: 'g',
              children: [
                {
                  type: 'path',
                  d: "M56.226 55.273h-5.718V23.825a.953.953 0 0 0-.953-.953H36.214V.953A.953.953 0 0 0 35.261 0H10.483a.953.953 0 0 0-.953.953v54.32H.953a.953.953 0 0 0 0 1.906h55.273a.953.953 0 0 0 0-1.906m-36.214 0H16.2V46.7a.953.953 0 0 1 .953-.953h1.907a.953.953 0 0 1 .953.953Zm3.812-31.449v31.449h-1.905V46.7a2.86 2.86 0 0 0-2.859-2.859h-1.906a2.86 2.86 0 0 0-2.859 2.859v8.577h-2.859V1.906h22.872v20.966h-9.53a.953.953 0 0 0-.953.953ZM48.6 55.273H25.731v-30.5H48.6Z"
                },
                {
                  type: 'path',
                  d: "M30.496 13.342h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812v-3.812h3.812Z"
                },
                {
                  type: 'path',
                  d: "M30.496 3.812h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953V4.765a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812V5.718h3.812Z"
                },
                {
                  type: 'path',
                  d: "M20.966 13.342h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812v-3.812h3.812Z"
                },
                {
                  type: 'path',
                  d: "M20.966 3.812h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953V4.765a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812V5.718h3.812Z"
                },
                {
                  type: 'path',
                  d: "M20.966 22.872h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812v-3.812h3.812Z"
                },
                {
                  type: 'path',
                  d: "M20.966 32.402h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953m-.953 5.718h-3.812v-3.812h3.812Z"
                },
                {
                  type: 'path',
                  d: "M39.072 43.838h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                },
                {
                  type: 'path',
                  d: "M39.072 34.308h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                },
                {
                  type: 'path',
                  d: "M39.072 53.367h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                },
                {
                  type: 'path',
                  d: "M29.543 43.838h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                },
                {
                  type: 'path',
                  d: "M29.543 34.308h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                },
                {
                  type: 'path',
                  d: "M29.543 53.367h5.718a.953.953 0 0 0 .953-.953v-5.718a.953.953 0 0 0-.953-.953h-5.718a.953.953 0 0 0-.953.953v5.718a.953.953 0 0 0 .953.953m.953-5.718h3.812v3.812h-3.812Z"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
